import React, { forwardRef, memo } from "react";

function _memoGeneric<A, B>(
  _Component: (props: A) => B
): (props: A) => React.ReactElement<any> | null {
  throw new Error("Not implemented");
}

function _forwardRefGeneric<T, P = {}>(
  _render: (props: P, ref: React.ForwardedRef<T>) => React.ReactElement<any> | null
): (props: P & React.RefAttributes<T>) => React.ReactElement<any> | null {
  throw new Error("Not implemented");
}

export const memoGeneric = memo as typeof _memoGeneric;
export const forwardRefGeneric = forwardRef as typeof _forwardRefGeneric;
